import Vue from 'vue'
import {FormatirajTelefonskoStevilko} from './GlobalnoTelefonija/FormatTelefonskeStevilke'

export const UrejenSeznamPrikljuckov = {
  methods: {
    UrediSeznam (vmesnik, izbranaStranka, seznamPrikljuckov = [], seznamOttPrikljuckov = []) {
      let pogrupiraniPrikljucki = []
      let vsiPrikljucki = []
      seznamPrikljuckov.concat(seznamOttPrikljuckov).filter(x => x.id_stranka === izbranaStranka).forEach(prikljucek => {
        if (prikljucek.umts_stevilka === '') {
          Vue.set(prikljucek, 'podatekZaIzpisPrikljucek', prikljucek.naslov)
        } else {
          Vue.set(
            prikljucek, 'podatekZaIzpisPrikljucek',
            FormatirajTelefonskoStevilko.methods.VrniFormatiranoTelefonsko(
              prikljucek.umts_stevilka, '5'
            )
          )
        }
        let najdenaSkupina = pogrupiraniPrikljucki.find(x => x.label === prikljucek.nazivSkupine)
        if (najdenaSkupina === undefined) {
          pogrupiraniPrikljucki.push(
            {'prikljucki': [prikljucek], 'label': prikljucek.nazivSkupine}
          )
        } else if (!najdenaSkupina.prikljucki.includes(prikljucek)) {
          najdenaSkupina.prikljucki.push(prikljucek)
        }
        vsiPrikljucki.push(prikljucek)
        this.izbranSap = prikljucek.id_stranka_sap
      })
      pogrupiraniPrikljucki.sort(function (a, b) {
        if (a.label === 'Mobilni priključki') {
          return -1
        } else if (b.label === 'Mobilni priključki') {
          return 1
        } else return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
      })
      let izbranPrikljucek = vsiPrikljucki.find(x => x.nazivSkupine === 'Mobilni priključki')
      if (vsiPrikljucki.length > 0) {
        vmesnik.GetUrejenSeznamPrikljuckov(vsiPrikljucki, pogrupiraniPrikljucki, izbranPrikljucek)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/UrejenSeznamPrikljuckov.js